import * as Rx from 'rxjs';
import { PersistService } from './PersistService';

export class AuthService {
    static getUser(fb) {
        if(fb.auth().currentUser) {
            return {
                email: fb.auth().currentUser.email,
                uid: fb.auth().currentUser.uid
            }
        } else {
            return null;
        }
    }

    static subscribeUser(fb) {
        return new Rx.Observable(observer => {
            fb.auth().onAuthStateChanged(user => observer.next(user));
        });
    }

    static deleteAccount(fb) {
        PersistService.setModel(fb, []);
        const user = fb.auth().currentUser
        user.delete();
    }

    static signOut(fb) {
        fb.auth().signOut();
    }
}


// WEBPACK FOOTER //
// ./src/services/AuthService.js